import { render, staticRenderFns } from "./ProductParameterSideBar.vue?vue&type=template&id=88e139ee&scoped=true&"
import script from "./ProductParameterSideBar.vue?vue&type=script&lang=js&"
export * from "./ProductParameterSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductParameterSideBar.vue?vue&type=style&index=0&id=88e139ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e139ee",
  null
  
)

export default component.exports